import { all, call } from "redux-saga/effects"
import { listFetchingFlow } from "./list/actions"

export function* authorsSaga() {
  yield all([call(listFetchingFlow)])
}

export { fetchAuthorsList } from "./list/actions"
